import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateLocationAreaDTO } from "../models/locationArea/locationArea.request";
import { LocationAreaSettingsInfoDTO, LocationAreaTableInfoDTO, SelectLocationAreaDTO } from "../models/locationArea/locationArea.response";



export const locationAreaService = {

    async Create(newLocationArea: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/locationareas", newLocationArea);
        return data;
    },

    async Update(id: string, updatedLocationArea: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locationareas/${id}`, updatedLocationArea);
        return data;
    },

    async Delete(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/locationareas/${id}`);
        return data;
    },

    async GetForSelect(cityId?: string): Promise<ApiResponse<SelectLocationAreaDTO[]>> {
        const { data } = await api.get<ApiResponse<SelectLocationAreaDTO[]>>("/locationareas/select", { params: { cityId } });
        return data;
    },

    async GetSettingsInfo(locationAreaId: string): Promise<ApiResponse<LocationAreaSettingsInfoDTO>> {
        const { data } = await api.get<ApiResponse<LocationAreaSettingsInfoDTO>>(`/locationareas/${locationAreaId}/settings`);
        return data;
    },

    async getTableInfo(): Promise<ApiResponse<LocationAreaTableInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<LocationAreaTableInfoDTO[]>>("/locationareas/table");
        return data;
    }

}